import { render, staticRenderFns } from "./DepartManage.vue?vue&type=template&id=c57c4206&scoped=true&"
import script from "./DepartManage.vue?vue&type=script&lang=js&"
export * from "./DepartManage.vue?vue&type=script&lang=js&"
import style0 from "./DepartManage.vue?vue&type=style&index=0&id=c57c4206&scoped=true&lang=css&"
import style1 from "./DepartManage.vue?vue&type=style&index=1&id=c57c4206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57c4206",
  null
  
)

export default component.exports